import { render, staticRenderFns } from "./Afiliados.vue?vue&type=template&id=2c4d9814&scoped=true&"
import script from "./Afiliados.vue?vue&type=script&lang=js&"
export * from "./Afiliados.vue?vue&type=script&lang=js&"
import style0 from "./Afiliados.vue?vue&type=style&index=0&id=2c4d9814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d9814",
  null
  
)

export default component.exports